import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';


const ProcessableAlert = ({ order }) => {

    let isProcessable;
    let explanation;

    if (!order.processable) {
        isProcessable = false;
        explanation = "No se puede procesar por falta de inventario"
    }

    else if (order.delivery && !order.delivery.label) {
        isProcessable = false;
        explanation = "No se puede procesar por falta de etiqueta de envío. Revise la dirección"
    }
    else {
        isProcessable = true;
        explanation = "Se puede procesar"
    }


    return (
    <Tooltip title={explanation}>
        <span>
            <Button disabled>
                <i className="material-icons-outlined delete-icon" style={ isProcessable ? { fontSize:"24px"} : { fontSize:"24px", color: '#ff6666'}}>error</i>
            </Button>
        </span>
    </Tooltip>
      );
    };

export default ProcessableAlert;